export default __webpack_public_path__ + "static/media/108 main cover.d38f0957.jpg";